import { bl_svc_issue_gendoc_link_RowClass } from '../../../dbschema/bl_svc_issue_gendoc_link.model';
import { BaseContainerModel } from '../../base-container.model';


export class ServiceIssueGenericDocLinkContainerModel extends BaseContainerModel {
  bl_svc_issue_gendoc_link: bl_svc_issue_gendoc_link_RowClass = new bl_svc_issue_gendoc_link_RowClass();
}
